var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.lastLogin)?_c('div',{staticClass:"last-login-info"},[_c('span',[_vm._v(_vm._s(_vm.$t("common.last_login"))+":")]),_c('span',[_vm._v(_vm._s(_vm.lastLogin))])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }